import { ActionControllerEventName, ResourcesManager, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { Vector3 } from 'three';
import { PickingControllerEvents } from "@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController";
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class TrashCanModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('micropipette_trash_can').clone();
        this.addObject(this.model);
        this.level = level;
    }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (!this.level.interaction)
                return;
            this.fire('holder_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
        if (this.level.lobby.app.zSpacePickingController) {
            const pipetteUiObject = this.level.instruments.pipette.uiObject;
            PreparationPickingObjects.saveObjectState(pipetteUiObject);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, pipetteUiObject, () => {
                const distanceToTrashCan = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(new Vector3(-22, -16, -15.3));
                if (distanceToTrashCan < 1.5) {
                    this.fire('holder_clicked');
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, pipetteUiObject);
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, pipetteUiObject);
                }
                else {
                    PreparationPickingObjects.flyObjectToPrevState(pipetteUiObject, 0);
                }
                setTimeout(() => pipetteUiObject.traverse(el => {
                    if (el.userData.oldRaycast)
                        el.raycast = el.userData.oldRaycast;
                }));
                this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
            });
        }
    }
}
